<template>
  <div>
    <v-toolbar v-if="$store.state.theme.toLowerCase()==='telekom'" color="primary" fixed height="16px" dark flat app>
    </v-toolbar>
  </div>
</template>
<script>
import Util from '@/util'

export default {
  name: 'toolbar',
  methods: {
    handleFullScreen () {
      Util.toggleFullScreen()
    },
    reload () {
      window.location.reload()
    },
    logout () {
      window.getApp.$emit('APP_LOGOUT')
    }
  }
}
</script>
